module.exports = __webpack_public_path__ + "img/icn_brand2.5957f867.svg";